// extracted by mini-css-extract-plugin
export var active = "SubNav-module--active--r+1KQ";
export var navLinks = "SubNav-module--navLinks--drdig";
export var page404Title = "SubNav-module--page404-title--OfhJl";
export var subNav_stuck = "SubNav-module--subNav_stuck--7bVX7";
export var subNavs_container = "SubNav-module--subNavs_container--30wh5";